module.exports = __webpack_public_path__ + "img/1476138934.e0cbb635.jpg";